export var FilterOperator;
(function (FilterOperator) {
    FilterOperator["IS"] = "is";
    FilterOperator["IS_NOT"] = "is_not";
    FilterOperator["CONTAINS"] = "contains";
    FilterOperator["BEFORE"] = "before";
    FilterOperator["AFTER"] = "after";
    FilterOperator["IS_ANY_OF"] = "is_any_of";
})(FilterOperator || (FilterOperator = {}));
//# sourceMappingURL=types.js.map